import { WebsiteDashboardData } from 'api/dashboardApi'
import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { getWebsiteOverallData_api } from "api/dashboardApi";
import dayjs from 'dayjs';

export type WebsiteDashboardDateRange = '7-days' | '30-days' | '3-months' | null

interface WebsiteDashboardState {
    isLoadingWebsiteDashboardData: boolean
    websiteDashboardData: WebsiteDashboardData | null
    getWebsiteDashboardData: (brandSlug: string, dateRange?: WebsiteDashboardDateRange) => Promise<WebsiteDashboardData | null>
    websiteDashboardDateRange: WebsiteDashboardDateRange
}

const useWebsiteDashboard = create(immer<WebsiteDashboardState>((set, get) => ({
    // State
    isLoadingWebsiteDashboardData: false,
    websiteDashboardData: null,
    websiteDashboardDateRange: null,

    // Methods
    getWebsiteDashboardData: async (brandSlug: string, dateRange?: WebsiteDashboardDateRange) => {
        set((state) => {
            state.isLoadingWebsiteDashboardData = true
        })

        const selectedDateRange: WebsiteDashboardDateRange = dateRange ?? get().websiteDashboardDateRange ?? '7-days';
        let websiteDashboardData: WebsiteDashboardData | null = null

        try {
            let startDate: dayjs.Dayjs | null = null;
            let endDate: dayjs.Dayjs | null = dayjs().startOf('day');

            switch (selectedDateRange) {
                case '7-days':
                    startDate = endDate.subtract(7, 'days')
                    break
                case '30-days':
                    startDate = endDate.subtract(30, 'days')
                    break
                case '3-months':
                    startDate = endDate.subtract(3, 'months')
                    break
            }

            if (startDate) {
                startDate = startDate.startOf('day')
            }

            websiteDashboardData = await getWebsiteOverallData_api(brandSlug, startDate?.format('YYYY-MM-DD'), endDate?.format('YYYY-MM-DD'))

            set((state) => {
                state.websiteDashboardData = websiteDashboardData
                state.websiteDashboardDateRange = selectedDateRange
            })
        } catch (error) {
            console.error('Error getting website dashboard data:', error)
        } finally {
            set((state) => {
                state.isLoadingWebsiteDashboardData = false
            })
        }

        return websiteDashboardData
    }
}))
)

export default useWebsiteDashboard
